import { render, staticRenderFns } from "./ReasonDialog.vue?vue&type=template&id=5b8c613a&"
import script from "./ReasonDialog.vue?vue&type=script&lang=js&"
export * from "./ReasonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports